import { BotId, BotMetadata } from '@feedyou/schema'
import { endpointHelpers } from '../../endpointHelpers'
import { FeedbotThunk } from '../../../../store/types'

export const getFullBotMetadataForBot =
  (id: BotId): FeedbotThunk<Promise<BotMetadata | undefined>> =>
  async (dispatch, getState) => {
    const response = await dispatch(endpointHelpers.getBotsMetadata.initiate()).unwrap()
    return response.metadata.find(metadata => metadata.id === id)
  }
